import type { ReactNode } from "react";
import { getSubdomain } from "../helpers/helpers";

type DomainFilterProps = {
  children?: ReactNode;
  inline?: boolean;
};

export const DomainFilter = ({ children, inline }: DomainFilterProps) => {
  const subdomain = getSubdomain();

  if (subdomain !== "localhost" && subdomain !== "app") return null;
  return <span className={inline ? "inline" : "contents"}>{children}</span>;
};
